<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-15 17:33:29
-->
<template>
    <Common>
      <template slot="cd">
          <CdhospitalPersonalList />
      </template>
      <template slot="sz">
          <SzhospitalPersonalList />
      </template>
      <template slot="hf">
          <HfhospitalPersonalList />
      </template>
    </Common>
</template>

<script>
import CdhospitalPersonalList from "@/components/hospitalPersonalList/cdPersonalList"
import SzhospitalPersonalList from "@/components/hospitalPersonalList/szPersonalList"
import HfhospitalPersonalList from "@/components/hospitalPersonalList/hfPersonalList"
export default{
  components:{
    CdhospitalPersonalList,
    SzhospitalPersonalList,
    HfhospitalPersonalList
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>